<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else>
      <headline-container :headline="person.data.name" :breadcrumbs="breadcrumbs">
        <div class="btn-group">
          <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-cogs"></i> Person Functions <span class="caret"></span>
          </button>

          <ul class="dropdown-menu">
            <li>
              <router-link :to="'/people/' + personId + '/subscriptions/create'">
                <i class="fa fa-plus"></i> Create Subscription
              </router-link>
            </li>

            <template v-if="person.data.company_id">
              <li v-if="person.data.has_partner_access">
                <a href="#" @click.prevent="deletePartnerAccess">
                  <i class="fa fa-minus"></i> Delete Partner Access
                </a>
              </li>

              <li v-else>
                <a href="#" @click.prevent="createPartnerAccess">
                  <i class="fa fa-plus"></i> Create Partner Access
                </a>
              </li>
            </template>

            <li v-if="hasPermission('admin')" role="separator" class="divider"></li>

            <li v-if="hasPermission('admin')">
              <a href="#" @click.prevent="destroy">
                <i class="fa fa-trash"></i> Delete
              </a>
            </li>
          </ul>
        </div>
      </headline-container>

      <sub-menu :person="person"></sub-menu>

      <div class="container" v-if="!person.data.is_active">
        <div v-if="person.data.new_person" class="alert alert-warning">
          The person is no longer active and has been replaced by
          <router-link :to="'/people/' + person.data.new_person_id">{{ person.data.new_person.name }}</router-link>
        </div>

        <div v-else class="alert alert-warning">
          The person is no longer active.
        </div>
      </div>

      <router-view v-model="person"></router-view>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import Load from '@/mixins/Load'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import Permissions from '@/mixins/Permissions'
import SubMenu from '@/pages/People/People/Edit/SubMenu'

export default {
  components: {HeadlineContainer, LoadingContainer, SubMenu},

  mixins: [Load, Permissions],

  props: ['personId'],

  data() {
    return {
      person: null
    }
  },

  mounted() {
    this.load({person: '/api/v1/people/' + this.personId})
  },

  watch: {
    '$route'() {
      this.load({person: '/api/v1/people/' + this.personId})
    }
  },

  computed: {
    breadcrumbs() {
      return [{url: '/people', text: 'People'}, {text: this.person.data.name}]
    }
  },

  methods: {
    createPartnerAccess() {
      modal.confirm('Are you sure that you want to give the person partner access?', () => {
        http.post('/api/v2/people/' + this.person.data.id + '/partner-access')
            .then(() => {
              notify.success('The partner access was created')

              this.person.data.has_partner_access = true
            })
            .catch(error => {
              if (error.response.status === 400) {
                notify.error(error.response.data.error)
              }
            })
      })
    },

    deletePartnerAccess() {
      modal.confirm('Are you sure that you want to remove partner access from the person?', () => {
        http.delete('/api/v2/people/' + this.person.data.id + '/partner-access')
            .then(() => {
              notify.success('The partner access was deleted')

              this.person.data.has_partner_access = false
            })
      })
    },
    destroy() {
      modal.confirm('Are you sure that you want to delete the person?', () => {
        http.delete('/api/v2/people/' + this.person.data.id)
            .then(() => {
              notify.success('The person was deleted')

              this.$router.push('/people')
            })
      })
    }
  }
}
</script>
